<template>
	<BaseColumn
		:size="1"
		:show-header="false"
	>
		<template #body>
			<div class="h-disp-flex h-flex-column">
				<div
					v-for="(item) in menuItems"
					:key="item.id"
					class="menu-item"
					:class="{selected: !!item.selected}"
				>
					<div class="menu-item--title">
						{{ item.label }}
					</div>
					<div class="menu-item--desc">
						{{ item.description }}
					</div>
					<div class="menu-item--icon">
						<Icon icon-name="right-arrow" />
					</div>
				</div>
			</div>
		</template>
	</BaseColumn>
</template>

<script>
import BaseColumn from '@videotools/js/one/components/Settings/BaseColumn';
import { mapGetters } from 'vuex';

export default {
	name:       'MainColumn',
	components: { BaseColumn },
	computed:   {
		...mapGetters({
			selectedTagGroup: 'tagGroups/selectedTagGroup',
		}),
		menuItems() {
			return [
				{
					label:       this.transChoiceUcFirst('tag_group.tag_group', 2),
					id:          'tag-groups',
					description: this.selectedTagGroup?.name,
					selected:    true,
				},
			];
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@videotools/sass/fonts';
@import '@shared/sass/shared-variables';

.settings-column {
	padding: 0;
}

::v-deep .body {
	padding: 0;
}

.menu-item {
	padding: 16px 24px;
	display: flex;
	border-bottom: 1px solid var(--color-grey-800);
	width: 100%;
	align-items: center;

	&--desc, &--icon {
		flex-shrink: 1;
	}

	&--title {
		@include text-md-2;
		flex-grow: 1;
		white-space: nowrap;
	}

	&.selected {
		background-color: var(--color-grey-900);
	}

	&--desc {
		@include text-sm-2;
		color: var(--color-grey-300);
		margin-right: 32px;
		text-align: right;
	}
}
</style>
